import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  // State
  username: string | null;
  userId: string | null;
  accessToken: string | null;
  expiresAt: string | null;
  userType: string | null;
  firstName: string | null;
  lastName: string | null;
  isAuthenticated: boolean;

  // Actions
  login: (
    username: string,
    userId: string,
    accessToken: string,
    expiresAt: string,
    userType: string | null,
    firstName: string | null,
    lastName: string | null,
  ) => void;
  logout: () => void;
  checkAuth: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      // Initial state
      username: null,
      userId: null,
      accessToken: null,
      expiresAt: null,
      userType: null,
      firstName: null,
      lastName: null,
      isAuthenticated: false,

      // Actions
      login: (
        username: string,
        userId: string,
        accessToken: string,
        expiresAt: string,
        userType: string | null,
        firstName: string | null,
        lastName: string | null,
      ) => {
        set({
          username,
          userId,
          accessToken,
          expiresAt,
          userType,
          firstName,
          lastName,
          isAuthenticated: true,
        });
      },

      logout: () => {
        set({
          username: null,
          userId: null,
          accessToken: null,
          expiresAt: null,
          userType: null,
          firstName: null,
          lastName: null,
          isAuthenticated: false,
        });
      },

      checkAuth: () => {
        const { accessToken, expiresAt } = get();
        if (!accessToken || !expiresAt) {
          return false;
        }
        // Check if token is expired
        const expirationDate = new Date(expiresAt);
        const now = new Date();
        if (expirationDate <= now) {
          get().logout();
          return false;
        }
        return true;
      },
    }),
    { name: "kitap-auth" },
  ),
);
